import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Button, Tag, Form, Popconfirm, message, Spin} from 'antd';
import type {TableColumnsType} from 'antd';
import {EditFilled, UnlockOutlined, LockOutlined} from '@ant-design/icons';
import {
  useGetShipToSystem,
  useGetSystemConfigById,
} from 'hooks/useSystemConfig/useGetSystemConfig';
import {TableCustom} from 'components/element/TableCustom';
import {PaginationCustom} from 'components/element/PaginationCustom';
import {RollbackOutlined} from '@ant-design/icons';
import {useToggleUser} from 'hooks/users/useUpdateUsers';
import {addKeyData, formatDate} from 'utils/index';
import {FormShip} from 'components/ship/FormShip';

export const ShipToSystem: React.FC = () => {
  const [form] = Form.useForm();
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [isId, setIsId] = useState('');
  const [filters, setFilters] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  const {data: dataById, isLoading: isLoadingById} = useGetSystemConfigById(
    params?.id || '',
  );
  const {data, isLoading, refetch, isError} = useGetShipToSystem({
    ...filters,
    systemConfigId: params?.id || '',
  });
  if (isError) {
    message.error('Không tìm thấy cửa hàng');
  }
  const {mutateAsync: onToggleUser} = useToggleUser();

  const handleConfirm = async (id: string) => {
    await onToggleUser(id);
    await refetch();
  };
  const columns: TableColumnsType = [
    {title: 'Tên tài xế', dataIndex: 'name', key: 'shop', width: 180},
    {
      title: 'Số điện thoại',
      dataIndex: 'user',
      key: 'numberPhone',
      width: 140,
      render: (data: any) => {
        return <div className="whitespace-nowrap">{data?.numberPhone}</div>;
      },
    },
    {
      title: 'Trạng thái',
      dataIndex: 'user',
      key: 'block',
      width: 140,
      render: (data: any) => {
        return (
          <Popconfirm
            title={`${data?.isBlocked ? 'Unblock' : 'Block'}`}
            description={`Bạn có chắc muốn ${
              data?.isBlocked ? 'Unblock' : 'Block'
            }`}
            okText="Yes"
            cancelText="No"
            onConfirm={() => handleConfirm(data?._id)}>
            {data?.isBlocked ? (
              <Button type="primary" icon={<UnlockOutlined />}>
                Unblock
              </Button>
            ) : (
              <Button
                icon={<LockOutlined />}
                className="!border-white bg-[#ed250e] hover:!bg-[#f25c4b] !text-white !font-medium">
                Block
              </Button>
            )}
          </Popconfirm>
        );
      },
    },
    {
      title: 'Xác minh',
      dataIndex: 'user',
      key: 'verified',
      width: 140,
      render: (data: any) => {
        return (
          <div className="whitespace-nowrap">
            {data?.verified ? (
              <Tag color="success">Đã xác minh</Tag>
            ) : (
              <Tag color="error">Chưa xác minh</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'center',
      width: 160,
      render: data => {
        return (
          <div className="whitespace-nowrap">
            <p>{formatDate(data)}</p>
          </div>
        );
      },
    },
    {
      title: 'Thao tác',
      dataIndex: '',
      key: 'action',
      align: 'center',
      width: 150,
      render: (text, record: any) => {
        return (
          <div className="flex gap-4 px-0">
            <Button
              onClick={() => {
                const data = {
                  ...record,
                  numberPhone: record.user.numberPhone,
                };
                setIsId(data?._id);
                form.setFieldsValue(data);
                setIsShowPopup(true);
              }}
              icon={<EditFilled />}
              className="!border-white	 bg-[#eca52b] hover:!bg-[#edb555] !text-white !font-medium">
              Chỉnh sửa
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <Spin spinning={isLoadingById}>
      <div className="container mx-auto">
        <div className="flex flex-col gap-4">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold">
              Bảng giá của : {dataById?.name}
            </h2>
            <Button
              icon={<RollbackOutlined />}
              onClick={() =>
                navigate('/system-config', {
                  state: {from: `/system-config/shop/${params.id}}`},
                })
              }>
              Trở về
            </Button>
          </div>
          <TableCustom
            isLoading={isLoading}
            columns={columns}
            data={addKeyData(data?.result)}
            scroll={{x: 910, y: 590}}
          />
          <PaginationCustom
            totalPage={data?.totalPage ?? 1}
            current={data?.page ?? 1}
            pageSize={data?.pageSize ?? 10}
            onChange={(page, pageSize) => {
              setFilters({...filters, page, pageSize});
            }}
            onShowSizeChange={(current, size) => {
              setFilters({...filters, page: current, pageSize: size});
            }}
          />
        </div>
      </div>
      <FormShip
        form={form}
        isShowPopup={isShowPopup}
        isId={isId}
        setIsShowPopup={setIsShowPopup}
        setIsId={setIsId}
        refetch={refetch}
      />
    </Spin>
  );
};
